import {
  init as initWorkshopHome,
  initLegacy as initWorkshopHomeLegacy,
} from './workshop-home';
import { init as initWorkshopServices } from './workshop-services';
import { init as initWorkshopProductPage } from './workshop-product-page';

export function init() {
  const $body = $('body');

  if ($body.hasClass('workshop')) initWorkshopHome();

  if ($body.hasClass('workshop-template')) initWorkshopHomeLegacy();

  if ($body.hasClass('workshop-services')) initWorkshopServices();

  if ($body.hasClass('workshop-product-page')) initWorkshopProductPage();
}



// WEBPACK FOOTER //
// ./src/workshop/workshop.entry.js